<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="facility-heading">View Tag</div>
    <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">View Tags</span>
          <span class="reviewstatus-{{tagStatus}}">{{tagStatus.toUpperCase()}}</span>
        </div>
        <div class="review-form-fileds">
          <span class="label" >Tag Name</span>
          <span class="answers">{{tag.tagName}}</span>
        </div>

        <div class="review-form-fileds">
          <span class="label">Categories</span>
          <span class="answers">
            <ul class="stacked-list">
              @for (category of selectedCategoryName; track category) {
                <li>
                  {{ category }}
                </li>
              }
            </ul>
          </span>
          <span></span>
        </div>
        <div class="h-30"></div>
        <div class="mb-10"></div>

        <div class="form-buttons" [hidden]="!showEditdButton">
          <button class="submit-form-button" (click)="navigate()">Edit</button>
          <a class="submit-form-button cancel-button" routerLink="/tags-list">Cancel</a>
        </div>

      </div>
    </form>
    <app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
  </div>

</div>
<app-footer></app-footer>
